export enum SortDirectionShared {
  UNKNOWN_SORTDIRECTION_TYPE = 0,
  ASC = 1,
  DESC = 2,
}
